import axios from 'axios';
import moment from 'moment';
import { PLANT_API_BASE_URL } from 'shared/constants/constants';

const validate = (validators, setErrors) => {
  const e2 = {};
  let errorsSummary = [];

  validators.forEach((v) => {
    e2[v.fieldName] = !v.isValid(v.fieldValue);
  });
  const isInvalid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);
  setErrors((errors) => ({ ...errors, ...e2 }));

  return !isInvalid;
};

const validateExt = (validators, setErrors, setErrorsSummary) => {
  const e2 = {};
  let errorsSummary = [];

  validators.forEach((v) => {
    const result = v.isValid(v.fieldValue);
    let invalid = false;
    let errorMessage = '';
    let errorSummaryMessage = '';

    if (typeof result === 'boolean' || typeof result === 'string') {
      invalid = !result;
      errorMessage = v.errorMessage instanceof Function ? v.errorMessage(v.fieldValue) : v.errorMessage;
      errorSummaryMessage = errorMessage;

      if (v.errorSummaryMessage) {
        errorSummaryMessage =
          v.errorSummaryMessage instanceof Function ? v.errorSummaryMessage(v.fieldValue) : v.errorSummaryMessage;
      }
    } else if (result && Object.keys(result).includes('status') && Object.keys(result).includes('errorMessage')) {
      invalid = !result.status;
      errorMessage = result.errorMessage;
      errorSummaryMessage = errorMessage;

      if (Object.keys(result).includes('errorSummaryMessage')) {
        errorSummaryMessage = result.errorSummaryMessage;
      }
    }

    if (invalid) {
      e2[v.fieldName] = { invalid, errorMessage };
      errorsSummary.push({ id: v.fieldName, text: errorSummaryMessage });
    }
  });

  const isInvalid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);

  setErrors(e2);

  if (setErrorsSummary) {
    setErrorsSummary(errorsSummary);
  }

  return !isInvalid;
};

const isSelected = (item) => {
  return item !== null && typeof item !== 'undefined';
};

const isSelecionComplete = (items) => {
  return items !== null && typeof items !== 'undefined' && items.length > 0;
};

const isCompleted = (val) => val && val.length >= 2;
const isNumeric = (val) => !!val && !isNaN(val);

const isDateValid = ({ day, month, year, date }) => {
  return !(
    !day ||
    isNaN(day) ||
    !month ||
    isNaN(month) ||
    !year ||
    isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid()
  );
};

const isAustralianPhoneNumberOrNull = (number) => {
  if (!number) return true;
  const re =
    /^\({0,1}((0|\+61|61)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
};

const isValidWebAddress = (webAddress) => {
  if (!webAddress) return true;
  const re =
    /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/i;
  return !(webAddress === null || !re.test(String(webAddress).toLowerCase()));
};

const isAustralianPhoneNumber = (number) => {
  const re =
    /^\({0,1}((0|\+61|61)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/i;
  return !(number === null || !re.test(String(number).toLowerCase()));
};

const isFileUploaded = (val) => {
  return val && Array.isArray(val) && val.filter((v) => v.status === 'done').length;
};

// const isDateValidAndPast = ({ day, month, year, date }) => {
//   return !(
//     !day ||
//     isNaN(day) ||
//     !month ||
//     isNaN(month) ||
//     !year ||
//     isNaN(year) ||
//     year < 1900 ||
//     !moment(`${year}-${month}-${day}`).isValid() ||
//     moment(`${year}-${month}-${day}`).isAfter(moment())
//   );
// };

// The date param here is a string with the format like '2000-02-20'.
const isDateValidAndPast = (date) => {
  return moment(date, 'YYYY-MM-DD', true).isValid() && moment(date).isBefore(moment());
};

const isAFutureDate = (day, month, year) => {
  if (year < 1900) return false;
  if (moment(`${year}-${month}-${day}`).isAfter(moment())) {
    return true;
  }

  return false;
};

const isDateValidAnd18Yo = ({ day, month, year, date }) => {
  return !(
    !day ||
    isNaN(day) ||
    !month ||
    isNaN(month) ||
    !year ||
    isNaN(year) ||
    year < 1900 ||
    !moment(`${year}-${month}-${day}`).isValid() ||
    !(moment().diff(`${year}-${month}-${day}`, 'years', true) >= 18) ||
    moment(`${year}-${month}-${day}`).isAfter(moment())
  );
};

const hasOwnershipData = ({ ownershipCorporations, ownershipPartners, ownershipTrusts, ownershipType }) => {
  if (ownershipType === 'self') {
    return true;
  }

  if (ownershipType === 'corporation') {
    if (ownershipCorporations.length > 0) {
      return true;
    } else {
      return false;
    }
  } else if (ownershipType === 'partner') {
    if (ownershipPartners.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  if (ownershipType === 'trust') {
    if (ownershipTrusts.length > 0) {
      return true;
    } else {
      return false;
    }
  }
};

const hasAnyValue = (array) => {
  return array && array.length > 0;
};

const isValidEmail = (email) => {
  const re =
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return !(email === null || !re.test(String(email).toLowerCase()));
};

const isAddressValid = (address) => {
  if (!address) {
    return false;
  } else {
    if (address.customType) {
      const a = address.value.details;
      return (
        a &&
        a.addressLine1 &&
        a.addressLine1.length > 2 &&
        a.suburb &&
        a.suburb.length > 2 &&
        a.state &&
        a.state.value !== null &&
        a.postcode &&
        a.postcode.length > 2 &&
        (!address.international || (address.international && a.country && a.country.length > 2))
      );
    } else {
      return true;
    }
  }
};

const isResidentialAddress = (addressDetails) => {
  const address = addressDetails?.details?.Address;

  return !address?.PostalDeliveryType;
};

const isStreetAddressValid = (address, maxLength) => {
  if (!address) return false;

  if (!address.enterManually) return true;

  return address.addressLine.length <= maxLength;
};

const clearError = (errName, errors, setErrors) => {
  const e2 = { ...errors };
  e2[errName] = false;
  setErrors(e2);
};

const clearErrors = (errors, setErrors) => {
  const e2 = { ...errors };
  Object.keys(e2).forEach((errName) => (e2[errName] = false));
  setErrors(e2);
};

const scrollToError = (errorSequences, errors) => {
  window.setTimeout(() => {
    const errorElements = document.querySelectorAll('[class*=ErrorMsg_error]');
    if (errorElements && errorElements.length > 0) {
      const yOffset = -150;
      const y = errorElements[0].getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, 100);
};

const countErrors = (obj) =>
  obj
    ? Object.keys(obj).reduce((acc, el) => {
        acc =
          typeof obj[el] === 'object'
            ? acc + countErrors(obj[el])
            : typeof obj[el] === 'string' && el === 'errorMessage' && obj[el] !== ''
            ? acc + 1
            : acc;
        return acc;
      }, 0)
    : 0;

const isValidPlaceOfBirth = (v, setPlaceOfBirthError) => {
  const validateIsAus = (data) =>
    undefined !== data?.isAustralia?.value && null !== data?.isAustralia?.value && '' !== data?.isAustralia?.value;
  const validateCountry = (data) =>
    (data?.isAustralia?.value === false && !!data?.country && !!data?.country?.value) ||
    data?.isAustralia?.value === true;
  const validateState = (data) =>
    (data?.isAustralia?.value === true && !!data?.state && !!data?.state?.value) || data?.isAustralia?.value === false;
  const validateSuburb = (data) =>
    (data?.isAustralia?.value === true &&
      !!data?.suburb &&
      !!data?.suburb?.value &&
      data?.suburb?.value?.trim().length > 2) ||
    data?.isAustralia?.value === false;

  const getErrorMessage = (data, key) => {
    switch (key) {
      case 'isAustralia':
        return validateIsAus(data) ? '' : 'Please select from the options provided';
      case 'country':
        return validateCountry(data) ? '' : 'Please select a country from the list provided';
      case 'suburb':
        return validateSuburb(data) ? '' : 'Value must be greater than 2 characters';
      case 'state':
        return validateState(data) ? '' : 'Please select a value';
      default:
        return '';
    }
  };

  const usedKeys = v ? Object.keys(v) : [];
  const requiredKeys = ['isAustralia', 'country', 'state', 'suburb'];
  const fullKeysArrayDups = [...usedKeys, ...requiredKeys];
  const fullKeysArray = fullKeysArrayDups.filter((item, pos) => fullKeysArrayDups.indexOf(item) === pos);

  const errors = fullKeysArray.reduce((acc, k) => {
    acc[k] = v && v[k] ? { ...v[k], errorMessage: getErrorMessage(v, k) } : { errorMessage: getErrorMessage(v, k) };
    return acc;
  }, {});

  const placeOfBirthWithErrors = { ...v, ...errors };
  const noErrors = countErrors(placeOfBirthWithErrors);
  console.log('placeOfBirthWithErrors', placeOfBirthWithErrors, noErrors);
  setPlaceOfBirthError(placeOfBirthWithErrors);
  return noErrors === 0;
};

const isValidOtherNames = (v, setOtherNamesError) => {
  let countHasNameErrorNo = 0;
  let hasOtherNames = false;

  const validateHasName = (data) =>
    undefined !== data?.hasName?.value && null !== data?.hasName?.value && '' !== data?.hasName?.value;
  const validateFirstName = (data) =>
    (hasOtherNames && !!data?.firstName && !!data?.firstName?.value) || !hasOtherNames;
  const validateLastName = (data) => (hasOtherNames && !!data?.lastName && !!data?.lastName?.value) || !hasOtherNames;

  const getErrorMessage = (data, key) => {
    switch (key) {
      case 'hasName':
        return validateHasName(data) ? '' : 'Please select from the options provided';
      case 'firstName':
        return validateFirstName(data) ? '' : 'Please enter a first name';
      case 'lastName':
        return validateLastName(data) ? '' : 'Please enter a last name';
      default:
        return '';
    }
  };

  const newVal = { ...v };
  if (newVal && newVal.hasName) {
    newVal.hasName.errorMessage = getErrorMessage(v, 'hasName');
  } else {
    newVal['hasName'] = { errorMessage: getErrorMessage(v, 'hasName') };
  }
  countHasNameErrorNo = countErrors(newVal?.hasName);
  hasOtherNames = newVal?.hasName?.value;

  let newNames = [];
  if (newVal && newVal.names) {
    const currNames = newVal?.names ? [...newVal.names] : [];

    newNames = currNames.map((cn, idx) => {
      const currName = cn || {};
      const usedKeys = currName ? Object.keys(currName) : [];
      const requiredKeys = ['firstName', 'lastName'];
      const fullKeysArrayDups = [...usedKeys, ...requiredKeys];
      const fullKeysArray = fullKeysArrayDups.filter((item, pos) => fullKeysArrayDups.indexOf(item) === pos);

      const errors = fullKeysArray.reduce((acc, k) => {
        acc[k] =
          currName && currName[k]
            ? { ...currName[k], errorMessage: getErrorMessage(currName, k) }
            : { errorMessage: getErrorMessage(currName, k) };
        return acc;
      }, {});

      return {
        ...currName,
        ...errors,
      };
    });
  }

  const otherNamesWithErrors = { ...newVal, names: [...newNames] };
  const noErrors = countErrors(otherNamesWithErrors);
  setOtherNamesError(otherNamesWithErrors);
  return noErrors === 0;
};

const isEmpty = (value) => {
  if (value == null) return true;

  if (typeof value !== 'string' && !(value instanceof String)) console.error('Invalid argumenent: ', value);

  return value.replace(/\s/g, '') === '';
};

const validateMaxCharacters = (value, maxCharacters) => {
  if (typeof value !== 'string') return true;

  if (!value) return true;

  return value.length <= maxCharacters;
};

const validateMandatoryAndMaxLength = (
  value,
  maxLength,
  mandatoryError = 'Please enter details',
  maxLengthError = `Maximum character limit is ${maxLength}`,
) => {
  let status = true;
  let errorMessage = '';

  if (isEmpty(value)) {
    status = false;
    errorMessage = mandatoryError;
  } else if (!validateMaxCharacters(value, maxLength)) {
    status = false;
    errorMessage = maxLengthError;
  }

  return { status, errorMessage };
};

const validateOptionalAndMaxLength = (value, maxLength, maxLengthError = `Maximum character limit is ${maxLength}`) => {
  let status = true;
  let errorMessage = '';

  if (!isEmpty(value) && !validateMaxCharacters(value, maxLength)) {
    status = false;
    errorMessage = maxLengthError;
  }

  return { status, errorMessage };
};

const validatePaymentCompleted = async (applicationId) => {
  return await axios.get(`${PLANT_API_BASE_URL}/applications/payment/status/${applicationId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

const validateFormattedAddress = (addressUi, isPoboxAllowed = false) => {
  const formattedAddressValue = addressUi?.formattedAddress?.value;

  if (isEmpty(formattedAddressValue)) return { status: false, errorMessage: 'Please enter valid address.' };

  if (!addressUi.validated.value)
    return {
      status: false,
      errorMessage: 'Enter a valid address. You can select an address from the list or enter manually.',
      errorSummaryMessage: 'Enter a valid address.',
    };

  if (formattedAddressValue.toLowerCase().startsWith('po box') && !isPoboxAllowed)
    return { status: false, errorMessage: 'PO Box address is not allowed.' };

  return { status: true, errorMessage: '' };
};

export {
  clearError,
  clearErrors,
  isSelected,
  isCompleted,
  isDateValid,
  isDateValidAndPast,
  isDateValidAnd18Yo,
  hasAnyValue,
  isNumeric,
  isValidEmail,
  isAddressValid,
  isResidentialAddress,
  isStreetAddressValid,
  isSelecionComplete,
  validate,
  isFileUploaded,
  isAustralianPhoneNumber,
  isAustralianPhoneNumberOrNull,
  scrollToError,
  isAFutureDate,
  hasOwnershipData,
  isValidWebAddress,
  isValidPlaceOfBirth,
  isValidOtherNames,
  isEmpty,
  validateExt,
  validateMaxCharacters,
  validateMandatoryAndMaxLength,
  validateOptionalAndMaxLength,
  validatePaymentCompleted,
  validateFormattedAddress,
};
